import { useMemo } from 'react';
import useArticle from 'vl-common/src/hooks/useArticle';

function formatArticle({ body }: { body: string }) {
  if (!body) return '';

  return body
    .replace(/<div( id="expander-control-.*?<\/)div>/g, '<summary$1summary>')
    .replace(/<div( id="expander-.*?<\/)div><\/div>/g, '<details$1div></details>');
}

export function useConfluenceArticle(articleName = 'CONF_SUPPORT') {
  const art = useArticle(articleName);

  return useMemo(() => (art ? formatArticle(art) : ''), [art]);
}

export default useConfluenceArticle;
